import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "emotion";
import { ShoppingBasket, Loyalty, Eco } from "@material-ui/icons";

import Container from "components/shared/Container";

import styleConfig from "styles/styleConfig";

const { colors, margin, padding, borderRadius, transition, boxShadow, screens } = styleConfig;

const infoStyle = css`
  background-color: ${colors.gray[100]};
  border: 1px solid ${colors.gray[200]};
  .container {
    .cards {
      display: flex;
      justify-content: space-between;
      padding: ${padding[4]};
      .card {
        color: ${colors.gray[600]};
        display: flex;
        .image {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 60px;
          width: 60px;
          margin-right: ${margin[2]};
          border: 1px solid ${colors.gray[600]};
          border-radius: ${borderRadius.full};
          svg {
            fill: ${colors.gray[600]};
          }
          transition: ${transition.default};
          &:hover {
            box-shadow: ${boxShadow.lg};
          }
        }
        span {
          line-height: 60px;
        }
      }
      @media (max-width: ${screens.MOBILE_WIDTH}px) {
        flex-direction: column;
        align-items: center;
        .card {
          margin: ${margin[2]};
        }
      }
    }
  }
`;

interface Props {}

const Info: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={infoStyle}>
      <Container className="container">
        <div className="cards">
          <div className="card">
            <div className="image">
              <ShoppingBasket />
            </div>
            <span>{t(`info.satisfaction_guarantee`)}</span>
          </div>
          <div className="card">
            <div className="image">
              <Loyalty />
            </div>
            <span>{t(`info.always_cheapest`)}</span>
          </div>
          <div className="card">
            <div className="image">
              <Eco />
            </div>
            <span>{t(`info.fresh_vegs_fruits`)}</span>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Info;
